 const OFIS_CASH_UZS = "5018"
const OFIS_CASH_USD = "5019"


export { OFIS_CASH_UZS, OFIS_CASH_USD }